<template>
  <div class="workspace-title">
    <WorkspaceIcon />
    <span class="name">{{ title || "Loading..." }}</span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

import WorkspaceIcon from "@/components/icons/WorkspaceIcon.vue";
import * as inject from "@/components/inject";
import { getWorkspace } from "@/composables/useProfile";

export default defineComponent({
  name: "WorkspaceTitle",
  components: {
    WorkspaceIcon,
  },
  props: {
    workspaceId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { workspaceId } = toRefs(props);
    const profile = inject.profile();

    const title = computed(
      () =>
        getWorkspace(profile.value, workspaceId.value)?.workspace.name ||
        "Workspace"
    );

    return {
      title,
    };
  },
});
</script>

<style lang="scss" scoped>
/* Match [OrganizationTitle.vue]: same flex row so labels align with other pinned items */
.workspace-title {
  display: flex;
  align-items: center;
  width: 100%;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
